import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const VerificationSuccessPage = () => {
  const location = useLocation();
  const selectedPlan = location.state?.selectedPlan;

  return (
    <>
      <Header />
      <div className="flex flex-col min-h-screen">
        <main className="flex-grow flex items-center justify-center bg-gray-100 dark:bg-gray-900">
          <div className="flex max-w-4xl w-full bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="bg-blue-600 dark:bg-blue-800 p-8 flex flex-col justify-between text-white w-1/3">
              <div>
                <h2 className="text-3xl font-semibold mb-6">Your selected plan</h2>
                {selectedPlan ? (
                  <>
                    <h3 className="text-2xl font-bold">{selectedPlan.title}</h3>
                    <p className="text-lg">{selectedPlan.price}/month</p>
                    <ul className="mt-4 space-y-2">
                      {selectedPlan.features.map((feature, index) => (
                        <li key={index} className="flex items-center">
                          <FontAwesomeIcon
                            icon={faCheck}
                            className="w-6 h-6 mr-2"
                          />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <p>No plan selected.</p>
                )}
              </div>
              <div className="mt-4">
                <a href="#" className="text-white text-sm underline">
                  Go back
                </a>
              </div>
            </div>

            <div className="p-8 w-2/3 flex flex-col justify-center items-center bg-white dark:bg-gray-800">
              <div className="mb-8">
                <div className="flex justify-between items-center">
                  <div className="flex items-center space-x-16">
                    {["Personal Info", "Account Info", "Confirmation"].map(
                      (step, index) => (
                        <div key={index} className="flex flex-col items-center ">
                          <FontAwesomeIcon
                            icon={faCheck}
                            className="w-6 h-6"
                            style={{ color: "#4964ED" }}
                          />
                          <span className="text-blue-600 dark:text-blue-400">{step}</span>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center">
                <svg
                  className="flex flex-start"
                  fill="#28a745"
                  width="32"
                  height="32"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <h2 className="text-3xl font-bold mb-2 text-black dark:text-white">
                  Verification Successful!
                </h2>
                <p className="text-gray-400 dark:text-gray-400 text-lg text-center">
                  Thank you for verifying your information. You can now enjoy
                  the features of the {selectedPlan?.title} plan.
                </p>
                <a
                  href="/login"
                  className="mt-6 px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                >
                  Login to your account
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default VerificationSuccessPage;
